export default "__VITE_ASSET__Dd876qDi__"